import React, { Component, PropTypes } from 'react';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchOption } from '../actions/';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import ViewOption from '../components/options/ViewOption';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  options: PropTypes.object,
  params: PropTypes.object,
  error: PropTypes.any,
};

class OptionViewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertOpen: false,
      alertMessage: '',
      edited: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.push('/');
    }
  }
  componentDidMount() {
    this.props.dispatch(fetchOption(this.props.params.id));
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="option component" style={authPage}>
        <h2>View Option</h2>
        <div className="content">
          <ViewOption
            option={this.props.options.option}
          />
        </div>
      </div>
    );
  }
}

OptionViewPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

OptionViewPage.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    options: state.options,
  };
}

export default withRouter(connect(mapStateToProps)(OptionViewPage));



// WEBPACK FOOTER //
// ./src/containers/OptionViewPage.js